import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';

import {
  SupplyWorkspacePicker,
  SupplyWorkspacePickerSchema,
} from './SupplyWorkspacePickerExtension';

export const SupplyWorkspacePickerExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    component: SupplyWorkspacePicker,
    name: 'SupplyWorkspacePicker',
    schema: SupplyWorkspacePickerSchema,
  }),
);
